import { forwardRef } from "react";
import { Stack, StackProps } from "@mui/material";

export const HorizontalStack = forwardRef<HTMLDivElement, StackProps>(
  (stackProps, ref) => {
    return (
      <Stack
        direction="row"
        spacing={{ xs: 2, md: 3 }}
        ref={ref}
        {...stackProps}
      />
    );
  },
);

HorizontalStack.displayName = "HorizontalStack";

export const VerticalStack = forwardRef<HTMLDivElement, StackProps>(
  (stackProps, ref) => {
    return (
      <Stack
        direction="column"
        spacing={{ xs: 2 }}
        ref={ref}
        {...stackProps}
      />
    );
  },
);

VerticalStack.displayName = "VerticalStack";
